import Box from '@amzn/meridian/box';
import Table, { TableCell, TableRow } from '@amzn/meridian/table';
import React from 'react';
import Text from '@amzn/meridian/text';
import getColorForText from './zoneMapColorHelper';

export interface ZoneMapLegendProps {
  zoneNameKeyMapping: Map<string, string>;
}

const ZoneMapLegend: React.FC<ZoneMapLegendProps> = ({ zoneNameKeyMapping }) => (
  <Box width="350px">
    <Table showDividers spacing="small" headerRows={1} layout="fixed">
      <TableRow>
        <TableCell>Abbreviation</TableCell>
        <TableCell>Zone Name</TableCell>
      </TableRow>
      {Array.from(zoneNameKeyMapping.entries()).map(([zoneName, zoneNameKey]) => (
        <TableRow key={zoneName}>
          <TableCell backgroundColor="secondary">
            <Text breakWord>{zoneNameKey}</Text>
          </TableCell>
          <TableCell backgroundColor={getColorForText(zoneName, true)}>
            <Text breakWord color="inverted">
              {zoneName}
            </Text>
          </TableCell>
        </TableRow>
      ))}
    </Table>
  </Box>
);

export default ZoneMapLegend;
